import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppOnlinePaymentAdyenComponent } from './app-online-payment/app-online-payment-adyen/app-online-payment-adyen.component';
import { AppOnlinePaymentFailedComponent } from './app-online-payment/app-online-payment-failed/app-online-payment-failed.component';
import { AppOnlinePaymentSuccessComponent } from './app-online-payment/app-online-payment-success/app-online-payment-success.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { NgxUiLoaderModule,POSITION,PB_DIRECTION, NgxUiLoaderConfig,NgxUiLoaderHttpModule, SPINNER } from  'ngx-ui-loader';
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatGridListModule} from '@angular/material/grid-list';
import { DatePipe } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import {MatDialogModule} from '@angular/material/dialog';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ItemStartdatePopupComponent } from './item-startdate-popup/item-startdate-popup.component';
import {MatRadioModule} from '@angular/material/radio';
import { CarouselModule } from 'ngx-owl-carousel-o';
import {MatExpansionModule} from '@angular/material/expansion';
import { PlanInfoPopupComponent } from './plan-info-popup/plan-info-popup.component';
import { TermsConditionPageComponent } from './terms-condition-page/terms-condition-page.component';
import { HomepageArabicComponent } from './homepage-arabic/homepage-arabic.component';
import { ItemStartdateArabicPopupComponent } from './item-startdate-arabic-popup/item-startdate-arabic-popup.component';
import { AppOnlinePaymentSuccessArabicComponent } from './app-online-payment/app-online-payment-success-arabic/app-online-payment-success-arabic.component';
import { AppOnlinePaymentFailedArabicComponent } from './app-online-payment/app-online-payment-failed-arabic/app-online-payment-failed-arabic.component';
import { TranslationService } from './service/translation.service';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#e0301e',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 80,
  blur: 0,
  fgsType: SPINNER.ballSpinClockwise,
  hasProgressBar:false,
  overlayColor: "rgba(40,40,40,0.12)",  
  minTime:10,  
};

export function initTranslations(ts: TranslationService) {
  return () => ts.loadTranslationsFromApi();
}

@NgModule({
  declarations: [
    AppComponent,
    AppOnlinePaymentAdyenComponent,
    AppOnlinePaymentFailedComponent,
    AppOnlinePaymentSuccessComponent,
    HomeComponent,
    TermsConditionComponent,
    AlertDialogComponent,
    ItemStartdatePopupComponent,
    PlanInfoPopupComponent,
    TermsConditionPageComponent,
    HomepageArabicComponent,
    ItemStartdateArabicPopupComponent,
    AppOnlinePaymentSuccessArabicComponent,
    AppOnlinePaymentFailedArabicComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    MatButtonModule,
    MatGridListModule,
    //NgbModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({showForeground:true}),
    MatIconModule,
    MatDialogModule,
    MatRadioModule,
    CarouselModule,
    MatExpansionModule
  ],
  providers: [MatDatepickerModule,DatePipe,{provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslations,
      deps: [TranslationService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
